export default "__VITE_ASSET__B4U6KjNN__"